"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var redirect_url_helper_1 = require("./redirect-url-helper");
var common_1 = require("@angular/common");
/**
 * Guard to check if requested user is logged
 */
var LoginGuard = /** @class */ (function () {
    function LoginGuard(authenticationService, router, cookieService, platformLocation) {
        this.authenticationService = authenticationService;
        this.router = router;
        this.cookieService = cookieService;
        this.platformLocation = platformLocation;
    }
    /**
     * Check if user logged then return true otherwise navigate on login page
     * @returns true if user is logged otherwise false
     */
    LoginGuard.prototype.canActivate = function (routeSnapshot, state) {
        var _this = this;
        this.authenticationService.redirectUrl = state.url;
        return this.authenticationService
            .isLoggedOn()
            .map(function (isLogged) {
            if (!isLogged) {
                _this.router.navigate(['/login']);
                return false;
            }
            else if (_this.cookieService.get('csrfToken')) {
                localStorage.setItem('csrfToken', _this.cookieService.get('csrfToken'));
                _this.cookieService.delete('csrfToken');
            }
            return isLogged;
        })
            .take(1);
    };
    LoginGuard.prototype.canLoad = function (route) {
        var _this = this;
        this.authenticationService.redirectUrl = redirect_url_helper_1.RedirectUrlHelper.getUrlAfterAppIdPart(this.platformLocation);
        return this.authenticationService
            .isLoggedOn()
            .map(function (isLogged) {
            if (!isLogged) {
                _this.router.navigate(['/login']);
                return false;
            }
            return isLogged;
        })
            .take(1);
    };
    LoginGuard = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.AuthenticationService,
            router_1.Router,
            idm_authentication_client_js_1.CookieService,
            common_1.PlatformLocation])
    ], LoginGuard);
    return LoginGuard;
}());
exports.LoginGuard = LoginGuard;
//# sourceMappingURL=login-guard.service.js.map